//
// Represents current login session for one user.
//
import gUtilities from '../script/utilities.js';
import { env } from '../env.js';

const k_exchange_path = '/portal';

class Session {
  constructor() {
    this.__session = null;
  }

  // Get the current user's DB data.
  user() {
    return this.__session.record;
  }

  version() {
    if (this.isLoggedIn()) {
      return this.__session.version;
    }

    return '0.0.0';
  }

  // Returns the server's release context { prod, test, dev }
  releaseContext() {
    return this.__session.context;
  }

  // Returns true if the server's release context is production
  isProduction() {
    return this.__session.context === 'prod';
  }

  async isLoginRequired() {
    return false;
  }

  isLoggedIn() {
    return this.__session !== null;
  }

  isInGroup(name) {
    if (!this.isLoggedIn()) {
      return false;
    }

    return this.__session.record.groups.includes(name);
  }

  //
  // Fetch data from /portal
  //
  async exchange(request) {
    let response;
    let path;

    try {
      path = env.REACT_APP_API_URL
        ? `${env.REACT_APP_API_URL}${k_exchange_path}` //to-do: need to fix env cache issue in npm build /portal
        : this.__lookupPath(request);
      response = await gUtilities.postJson(path, request);
     /*  response = env.REACT_APP_API_URL
        ? response.result.body.response
        : response; */
    } catch (ex) {
      response = { isError: true, message: ex.toString() };
    }

    return response;
  }

  async login(username, password) {
    let onceword;
    let isHashed;

    if (gUtilities.isCryptoAvailable()) {
      isHashed = true;
      onceword = await gUtilities.sha256(password);
    } else {
      return { isError: true, message: "Crypto is not available" };
    }

    let request = {
      service: 'user.login',
      username: username,
      onceword: onceword,
      is_hashed: isHashed,
      session_token: 'LOGIN',
    };

    let response;
    try {
      response = await this.exchange(request);
    } catch (ex) {
      response = { isError: true, message: ex.toString() };
    }

    if (!response.isError) {
      this.__session = response.session;
      response = {};
    }

    return response;
  }

  async logout() {
    let request = {
      service: 'user.logout',
    };

    let response;
    try {
      response = await this.exchange(request);
    } catch (ex) {
      response = { isError: true, message: ex.toString() };
    }

    this.__session = null;

    if (response.isError) {
      alert('ERROR: ' + response.message);
      return false;
    }

    return true;
  }

  __lookupPath(request) {
    return k_exchange_path;
  }
}

const gSession = new Session();

export default gSession;
